// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ChiusuraRipristinoEsercizioDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ChiusuraRipristinoEsercizioApiClient extends BaseCRUDApiClient<ChiusuraRipristinoEsercizioDto> {
  baseUrl = this.config.apiEndpoint + '/chiusura-ripristino-esercizio';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  checkEsercizioClosed() {
    return this.http.get<boolean>(this.baseUrl + '/check-esercizio-chiuso');
  }

  chiusuraEsercizio() {
    this._pagedCache.clear();
    return this.http.get(this.baseUrl + '/chiusura-esercizio');
  }

  ripristinoEsercizio() {
    this._pagedCache.clear();
    return this.http.get(this.baseUrl + '/ripristino-esercizio');
  }
}
